import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Log } from 'ng2-logger';
import { InsertionCycle } from '@app/shared/models/insertion-cycle.model';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-tool-insertion-cycles-form',
  templateUrl: './tool-insertion-cycles-form.component.html',
  styleUrls: ['./tool-insertion-cycles-form.component.scss']
})
export class ToolInsertionCyclesFormComponent implements OnInit, OnChanges {

  _logger = Log.create(ToolInsertionCyclesFormComponent.name);

  @Input() selectedInsertionCycles: InsertionCycle[] = [];
  @Input() availableInsertionCycles: InsertionCycle[] = [];
  @Input() showValidations = false;
  @Input() isSPI = false;

  form: UntypedFormGroup;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['availableInsertionCycle'] || changes['selectedInsertionCycles'] || changes['isSPI']) &&
        this.form && this.selectedInsertionCycles) {
      this.loadFormValues(this.selectedInsertionCycles);
    }
  }

  ngOnInit() {
    this.initForm();
  }

  submit() {
    this._logger.info('submit::')
  }

  initForm() {
    this.form = new UntypedFormGroup({
      insertionCycles: new UntypedFormControl(this.selectedInsertionCycles),
    });
  }

  loadFormValues(selectedInsertionCycles: InsertionCycle[]) {
    this.form.reset();
    this.form.setValue({
      insertionCycles: selectedInsertionCycles
    });

    this.checkForDisable();
  }

  checkForDisable() {
    const insertionCyclesControl = this.form.get("insertionCycles");
    !this.isSPI ? insertionCyclesControl.disable() : insertionCyclesControl.enable();
  }

  resetForm() {
    this._logger.info("resetForm:: with", this.availableInsertionCycles);
    this.showValidations = false;
    this.form.reset();
  }

  getFormValue() {
    return this.form.getRawValue();
  }

  get isFormValid() {
    this.showValidations = true;
    return this.form.valid;
  }
}
